import React from 'react';
import { __APPLICATION_SETTINGS } from '../__applicationSettings';
export const UserContext = React.createContext(__APPLICATION_SETTINGS ? {
    permissions: __APPLICATION_SETTINGS.acl.permissions,
    features: __APPLICATION_SETTINGS.account.features,
    featureToggles: __APPLICATION_SETTINGS.featureToggles,
    crypto: __APPLICATION_SETTINGS.crypto,
    userId: __APPLICATION_SETTINGS.accountMetrics.userId,
    userIdN: __APPLICATION_SETTINGS.accountMetrics.userIdN,
    packet: __APPLICATION_SETTINGS.account.accountBilling.packet,
    plan: __APPLICATION_SETTINGS.accountMetrics.plan,
    email: __APPLICATION_SETTINGS.account.email,
    firstName: __APPLICATION_SETTINGS.account.firstName,
    lastName: __APPLICATION_SETTINGS.account.lastName,
    isCollaborator: __APPLICATION_SETTINGS.acl.isCollaborator,
    accountType: __APPLICATION_SETTINGS.account.accountType,
    daysToExpiration: __APPLICATION_SETTINGS.account.daysToAccountExpiration,
    isAccountOwner: __APPLICATION_SETTINGS.account.isAccountOwner,
    maxOfferSystem: __APPLICATION_SETTINGS.maxOfferSystem,
    collaboratorOwnerEmail: __APPLICATION_SETTINGS.account.collaboratorOwnerEmail,
    dashboardLanguage: __APPLICATION_SETTINGS.dashboardLanguage,
} : null);
UserContext.displayName = 'UserContext';
//# sourceMappingURL=UserContext.js.map